/**
 * A work of Art within an Exhibition
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

export { WorkInExhibition };

 /** Work in a Collection */
class WorkInExhibition {

	constructor(model, data) {
		this.model = model;
		this.linkExhibition = data.linkExhibition;
		this.linkWorkOfArt = data.linkWorkOfArt;
		this.seqDisplay = parseInt(data.seqDisplay);
		this.seqLink = parseInt(data.seqLink);

		this.descriptionDE = data.descriptionDE;
		this.descriptionEN = data.descriptionEN;
		this.descriptionFR = data.descriptionFR;

		// Relations
		this.work = null;
		this.exhibition = null;

		// display sort index
		this.indexByLink = 0;
	}

	getWork() {
		return this.work;
	}
	
	setWork(workRef) {
		this.work = workRef;
	}
	
	getExhibition() {
		return this.exhibition;
	}
	
	setExhibition(exhibitionRef) {
		this.exhibition = exhibitionRef;
	}

	setIndexByLink(index) {
		this.indexByLink = index;
	}

	getIndexByLink() {
		return this.indexByLink;
	}

	//
	// Allow the Work of Art to act as a Work while overloading some behaviour
	//

	/** Get the basic (unencoded) URL Term form for this entity */
	getURLTerm() {
		return this.getID();		
	}

	/** Equality Test Used for URL Resovling */
	acceptURLTerm(term) {
		return this.getURLTerm() == term;
	}

	/** Get the Tool Tip Text for this Work of Art */
	getToolTip() {
		return this.getArtistLabel() + ' - ' + this.getTitle() + ' (' + this.getYear() + ')';
	}

	getID() {
		return this.work.getID();
	}
	
	getTitle() {
		return this.work.getTitle();
	}
	
	getCopyright() {
		return this.work.getCopyright();
	}

	// Description is overwriten by exhibition
	getDescription() {
		if (this.model.getLang() == 'en') {
			return this.descriptionEN.replace(/\n/g, "<br>");
		} else if (this.model.getLang() == 'fr') {
			return this.descriptionFR.replace(/\n/g, "<br>");
		} else {
			return this.descriptionDE.replace(/\n/g, "<br>");
		}		
	}
	
	getLocation() {
		return this.work.getLocation();
	}
	
	getOrigin() {
		return this.work.getOrigin();
	}

	getYear() {
		return this.work.getYear();
	}
	
	getTechnique() {
		return this.work.getTechnique();
	}
	
	getFlagTimeline() {
		return this.work.getFlagTimeline();
	}
	
	getImages() {
		return this.work.getImages();
	}
	
	getTags() {
		return this.work.getTags();
	}
	
	hasTag(tag) {
		return this.work.hasTag(tag);
	}
	
	getArtists() {
		return this.work.getArtists();
	}
	
	getCollections() {
		return this.work.getCollections();
	}
	
	isInCollection(collection) {
		return this.work.isInCollection(collection);
	}
	
	getExhibitions() {
		return this.work.getExhibitions();
	}
	
	accept(filter) {
		return this.work.accept(filter);
	}
	
	getSize() {
		return this.work.getSize();
	}
	
	getArtistLabel() {
		return this.work.getArtistLabel();
	}
	
	getCollectionsLabel() {
		return this.work.getCollectionsLabel();
	}

	getPrimaryImageAspectRatio() {
		return this.work.getPrimaryImageAspectRatio();
	}	

	// Lookup the Selection State
	getIsInSelection() {
		return this.work.getIsInSelection();
	}

	// Update the Selection State
	setIsInSelection(value) {
		this.work.setIsInSelection(value);
	}

}